import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logoImg from '../assets/logo2.png'; // ✅ este é o import que faltava

export const exportarProfessores = (
  professores,
  formato,
  titulo = "Lista de Professores no sistema",
  nomeArquivoBase = "ACADE_professores_exportados",
  nomeEscola = "Escola Vida Abundante"
) => {
  if (!professores || professores.length === 0) {
    alert("Nenhum dado para exportar.");
    return;
  }

  const nomeArquivo = `${nomeArquivoBase}_${new Date().toISOString().slice(0, 10)}`;

  // Somente os campos necessários
  const colunas = ["Nome", "Nível Acadêmico", "Disciplinas", "Classes", "Contacto"];

  const dadosNormalizados = professores.map((prof) => {
    const normalizar = (valor) => (valor && valor.toString().trim() !== "" ? valor : "—");

    return {
      Nome: normalizar(prof.Nome || prof.nome),
      "Nível Acadêmico": normalizar(prof.NivelAcademico || prof.nivelAcademico),
      Disciplinas: normalizar((prof.Disciplinas || []).join(", ")),
      Classes: normalizar((prof.Classes || []).join(", ")),
      Contacto: `${normalizar(prof.Telefone || prof.telefone)} / ${normalizar(prof.Email || prof.email)}`
    };
  });

  if (formato === "pdf") {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = logoImg; // ✅ variável importada corretamente


    img.onload = () => {
      const imgWidth = 40;
      const aspectRatio = img.height / img.width;
      const imgHeight = imgWidth * aspectRatio;

    
      doc.addImage(logoImg, "PNG", 10, 10, 40, 20); // <- ERRO aqui se logoImg não estiver definido


      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text(`ACADE - ${titulo}`, 60, 20);

      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.text(`${nomeEscola}`, 60, 30);

      autoTable(doc, {
        head: [colunas],
        body: dadosNormalizados.map((prof) => colunas.map((campo) => prof[campo])),
        startY: 45,
        styles: {
          fontSize: 11,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center",
        },
        margin: { top: 10 },
      });

      doc.save(`${nomeArquivo}.pdf`);
    };
  } else if (formato === "excel" || formato === "csv") {
    const dadosExportacao = dadosNormalizados.map((prof) =>
      colunas.reduce((acc, campo) => {
        acc[campo] = prof[campo];
        return acc;
      }, {})
    );

    if (formato === "excel") {
      const ws = XLSX.utils.json_to_sheet(dadosExportacao);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Professores");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      saveAs(blob, `${nomeArquivo}.xlsx`);
    } else {
      const csvLinhas = dadosExportacao.map((prof) =>
        colunas.map((campo) => `"${prof[campo]}"`).join(",")
      );
      const csvContent = `${colunas.join(",")}\n${csvLinhas.join("\n")}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${nomeArquivo}.csv`);
    }
  } else {
    alert("Formato de exportação não suportado.");
  }
};
